import { shouldShowMailCommandCenterPlaceholder } from 'owa-copilot-command-center-components/lib/utils/shouldShowMailCommandCenterPlaceholder';
import { setShouldRenderCommandCenterPlaceholderMutator } from 'owa-copilot-command-center-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { updateBizchatEnabledMutator } from 'owa-sidepane-bizchat-store';
import { getBootM365Acquisitions } from 'owa-m365-acquisitions/lib/getBootM365Acquisitions';
import getBizChatAppId from 'owa-m365-acquisitions/lib/utils/getBizChatAppId';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export function initializeCopilotCommandCenter(mailboxInfo: MailboxInfo): void {
    if (!isFeatureEnabled('mon-copilot-command-center-preload')) {
        return;
    }
    if (shouldShowMailCommandCenterPlaceholder(window)) {
        setShouldRenderCommandCenterPlaceholderMutator(true);
    }
    getBootM365Acquisitions(mailboxInfo).then(acquisitions => {
        const bizchatAppId = getBizChatAppId(mailboxInfo);
        const bizchatAcquisition = acquisitions.find(
            acquisition => acquisition.appId === bizchatAppId
        );
        if (bizchatAcquisition !== undefined) {
            const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
            updateBizchatEnabledMutator(
                accountKey,
                true,
                bizchatAcquisition?.titleDefinition?.eligibility ?? undefined
            );
        }
    });
}
